import { useCallback } from "react"

interface RenameArgs {
  id: string
  original_filename: string
}

type BoundRenameAttachment = (args: RenameArgs) => {
  unwrap: () => Promise<unknown>
}

/**
 * Adapts the connected `renameAttachment` action to what the file cards call.
 *
 * `unwrap` is the point: without it a rejected rename settles as a fulfilled
 * promise and the modal closes as though the file had been renamed.
 */
export const useRenameAttachment = (renameAttachment: BoundRenameAttachment) =>
  useCallback(
    async (attachmentId: string, nextFileName: string) => {
      await renameAttachment({
        id: attachmentId,
        original_filename: nextFileName
      }).unwrap()
    },
    [renameAttachment]
  )
